import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useExperimentalSiteUserPersonalization } from '@confluence/targeting/entry-points/useExperimentalSiteUserPersonalization.ts';

export const useModernizeChangeboardingTapTraits = () => {
	const { cloudId, userId } = useSessionData();

	const { loading, data, error } = useExperimentalSiteUserPersonalization({
		variables: { cloudId, userId: userId ?? '' },
		skip: !userId,
	});

	if (!data) {
		return {
			isInNav4Audience: false,
			hasDismissedNav4ChangeboardingViaEP: false,
			loading,
			error,
		};
	}

	let isInNav4Audience = false;
	let hasDismissedNav4ChangeboardingViaEP = false;
	for (const { name, value } of data.experimentalSiteUserPersonalization?.attributes ?? []) {
		if (name === 'segment_confluence_nav_4_changeboarding_cloned_siteuser') {
			isInNav4Audience = value === 'true';
		} else if (name === 'completed_cc-nav-4-changeboarding-prod') {
			hasDismissedNav4ChangeboardingViaEP = Boolean(value);
		}
	}

	return {
		isInNav4Audience,
		hasDismissedNav4ChangeboardingViaEP,
		loading,
		error,
	};
};
